<template>
  <div class="overflow-auto w-full flex flex-col h-full">
    <userEditModal
      :rowId="rowId"
      :orderNo="orderNo"
      :vehicle="selected"
      @refresh="getAll"
      :activeSpot="activeSpot"
    />
    <addModal
      :orderItem="orderItem"
      :customers="customers"
      :customerList="customerList"
      :orderNo="orderNo"
      :rowId="rowId"
      :selectedEquipmentCategories="selectedEquipmentCategories"
      @open-equipment-modal="openEquipmentModal"
      @refresh="() => ($emit('refresh', true), getAll())"
    />
    <equipmentSelectorModal
      :initialSelectedCategories="selectedEquipmentCategories"
      @equipment-selected="handleEquipmentSelected"
    />
    <piratedriverModal
      :item="orderItem"
      @refresh="() => ($emit('refresh', true), getAll())"
      :orderNo="orderNo"
      :rowId="rowId"
    />
    <headerItem :orderItem="orderItem" />
    <!-- İyileştirilmiş Toolbar Bölümü -->
    <div class="w-full items-center md:flex space-y-2 my-3">
      <div
        class="md:flex items-center w-full md:w-3/5 px-4 md:space-x-2 md:space-y-0 space-y-2"
      >
        <!-- Yeni Araç Butonu - Daha geniş, iyi hizalı ve hover efektleri -->
        <button
          @click="!isArchived && !isDisabled && $modal.show('add-vehicle-modal')"
          :disabled="isDisabled || isArchived"
          :class="
            isDisabled || isArchived
              ? 'opacity-50 cursor-not-allowed bg-gray-300 text-gray-600'
              : 'btn-add-vehicle'
          "
          class="w-1/4 flex whitespace-nowrap items-center justify-center px-4 py-2 rounded-md transition-all duration-200 font-medium text-sm shadow-sm"
        >
          <i class="fas fa-plus mr-2"></i> Yeni Araç
        </button>

        <!-- Korsan Araç Ekle Butonu - Aynı stil ile tutarlı -->
        <button
          @click="!isArchived && !isDisabled && $modal.show('pirate-driver-plan-modal')"
          :disabled="isDisabled || isArchived"
          :class="
            isDisabled || isArchived
              ? 'opacity-50 cursor-not-allowed bg-gray-300 text-gray-600'
              : 'btn-add-vehicle-pirate'
          "
          class="w-1/4 whitespace-nowrap flex items-center justify-center px-4 py-2 rounded-md transition-all duration-200 font-medium text-sm shadow-sm"
        >
          <i class="fas fa-plus mr-2"></i> Korsan Araç Ekle
        </button>

        <!-- Geliştirilmiş Arama Alanı - Daha net görünüm -->
        <div class="relative w-full md:w-2/4">
          <input
            type="text"
            v-model="searchQuery"
            @keyup.enter="handleSearch"
            placeholder="Ara ve Enter'a bas..."
            class="w-full px-4 py-2 pl-10 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-300 transition-all duration-200"
          />
          <i
            class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          ></i>
        </div>
      </div>
      <div class="flex items-center w-full md:w-2/5 px-4 space-x-2">
        <asyncBtn
          @click="stopControl()"
          :loadState="stopAllLoading"
          text="Tümünü Durdur"
          icon="fa-stop"
          size="py-2"
          containerClass=" whitespace-nowrap "
          :disabled="!canStopAll || isArchived"
          :containerClass="
            !canStopAll || isArchived
              ? 'w-1/2 h-10 bg-gray-400 cursor-not-allowed opacity-50'
              : 'w-1/2 h-10 bg-red-600 hover:bg-red-700 transition-colors duration-200'
          "
        />
        <asyncBtn
          @click="startControl()"
          :loadState="startAllLoading"
          text="Tümünü Başlat"
          icon="fa-play"
          size="py-2"
          :disabled="!canStartAll || isArchived"
          containerClass=" whitespace-nowrap"
          :containerClass="
            !canStartAll || isArchived
              ? 'w-1/2 h-10 bg-gray-400 cursor-not-allowed opacity-50 '
              : 'w-1/2 h-10 bg-green-600 hover:bg-green-700 transition-colors duration-200'
          "
        />
      </div>
    </div>
    <!-- Toplu İşlem Butonları -->
    <div class="h-3/6 overflow-auto w-full px-4">
      <table
        class="w-full divide-y divide-gray-200 shadow border-b overflow-y-scroll border-gray-200 bg-gray-200 dark:bg-gray-900 sm:rounded-lg"
      >
        <thead
          class="bg-white border-black border-dotted border-b-2 border-opacity-20"
        >
          <tr>
            <th scope="col" class="table-th text-center">#</th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 190px !important"
            >
              Araç
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 100px !important"
            >
              Dorse
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 160px !important"
            >
              Sürücü
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 120px !important"
            >
              Sefer Sayısı
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 120px !important"
            >
              Son Durum
            </th>
            <th
              v-if="isBulk"
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 120px !important"
            >
              Sipariş Durumu
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
              style="min-width: 180px !important"
            >
              Başlat / Durdur
            </th>
            <th
              scope="col"
              class="table-th text-left border-r border-opacity-20"
            >
              #
            </th>
          </tr>
        </thead>
        <tbody
          class="divide-y-2 divide-gray-500"
          style="background-color: #3a3a3a"
        >
          <tr v-for="(item, index) in List" :key="item.id" class="p-1">
            <td class="table-td text-center border-r border-opacity-20">
              {{ index + 1 + currentPage * 20 }}
            </td>
            <td class="table-td border-r border-opacity-20">
              <div class="flex justify-between items-center">
                <p class="whitespace-nowrap">{{ item.plaque }}</p>
                <span
                  class="text-white text-xs inline-block font-extralight"
                  v-if="item.isCustom == 1 || item.isReject == 1"
                >
                  <div
                    v-if="item?.isReject == 1"
                    class="bg-red-600 px-2 rounded-xl"
                  >
                    {{
                      item?.changeRejectId == 1 ? "Reddetti" : "İptal Edildi"
                    }}
                  </div>
                  <div v-else>
                    <div class="flex items-center justify-between">
                      <div class="ml-2 flex items-center justify-between">
                        <span
                          @click="
                            swalBox(
                              'info',
                              'BİLGİ',
                              item.isPirateDriver == 1
                                ? 'Firma dışından bağımsız bir sürücüye (korsan araç) atandı.'
                                : 'Operasyon personeli, önerilen araçlar yerine bu aracı manuel olarak seçti.'
                            )
                          "
                          style="font-size: 11px"
                          class="px-2 rounded-xl cursor-pointer select-none text-white inline-block font-extralight whitespace-nowrap"
                          :class="
                            item.isPirateDriver == 1
                              ? 'bg-yellow-600'
                              : 'bg-red-600'
                          "
                          v-if="item.isCustom == 1 || item.isPirateDriver == 1"
                          :title="
                            item.isPirateDriver == 1
                              ? 'Firma dışından bağımsız bir sürücüye (korsan araç) atandı'
                              : 'Operasyon personeli, önerilen araçlar yerine bu aracı manuel olarak seçti'
                          "
                        >
                          <i class="fas fa-info-circle"></i>
                          {{
                            item.isPirateDriver == 1
                              ? "Korsan Atama"
                              : "Manuel Atama"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </td>
            <td class="table-td border-r border-opacity-20">
              <p>{{ item.dorse }}</p>
            </td>
            <td class="table-td border-r border-opacity-20">
              <p>{{ item.name }}</p>
            </td>
            <td
              class="table-td border-r border-opacity-20 font-bold text-center"
            >
              <p>{{ item.transitionCount }}</p>
            </td>
            <td
              class="table-td border-r border-opacity-20 font-bold text-center"
            >
              <p>{{ item.lastStateName || "Rapor Yok" }}</p>
            </td>
            <td
              v-if="isBulk"
              class="table-td border-r border-opacity-20 text-center"
            >
              {{ item.isTaskActive == 1 ? "Mevcut Sipariş" : "Bağlı Sipariş" }}
            </td>
            <td
              class="table-td border-r border-opacity-20 font-bold text-center"
            >
              <asyncBtn
                :loadState="vehicleActionLoading[item.id] || false"
                @click="() => !isArchived && (stopedControl(item), $emit('refresh', true))"
                :text="item.isStopped == 2 ? 'Durdur' : 'Başlat'"
                :disabled="isArchived"
                icon=""
                size="py-1 "
                :containerClass="
                  isArchived
                    ? 'bg-gray-400 cursor-not-allowed opacity-50 w-40'
                    : item.isStopped === 1
                    ? 'bg-green-700 hover:bg-green-500 w-40'
                    : 'w-40'
                "
              />
            </td>
            <td class="table-td border-r border-opacity-20 flex">
              <div class="flex p-1">
                <button
                  v-if="orderItem.TransitionType == 2"
                  :class="
                    isDisabled || isArchived || item?.lastStateId !== '8'
                      ? 'text-white  rounded px-2 py-1 border-opacity-30 bg-opacity-30 text-opacity-30 mr-2 cursor-default pointer-events-none'
                      : 'process-btn mr-2'
                  "
                  :disabled="isArchived"
                  @click="!isArchived && item?.lastStateId == 8 && addNewTask(item)"
                  :title="
                    item?.isExtraTourActive
                      ? 'Bu Araç birden fazla kez iş atabilir.'
                      : item?.lastStateId === '8'
                      ? 'Bu araca ek sefer ekle'
                      : 'Ek sefer eklemek için aracın son durumu 8 (Tamamlandı) olmalıdır'
                  "
                >
                  <i
                    v-if="newTaskLoading[item.id]"
                    class="fas fa-spinner fa-spin"
                  ></i>
                  <i class="fas fa-plus" v-else></i>
                  Ek Sefer
                </button>
                <button
                  :class="isArchived ? 'text-white border rounded px-2 py-1 border-opacity-30 bg-opacity-30 text-opacity-30 cursor-default' : 'process-btn mr-2'"
                  :disabled="isArchived"
                  @click="!isArchived && userEditModal(item)"
                  title="Araç bilgilerini düzenle"
                >
                  <i class="fas fa-pen"></i>
                  Düzenle
                </button>
                <button
                  :class="
                    isDisabled || isArchived
                      ? 'text-white border rounded px-2 py-1 border-opacity-30 bg-opacity-30 text-opacity-30 cursor-default'
                      : 'process-btn'
                  "
                  :disabled="isDisabled || isArchived"
                  @click="!isArchived && deleteItem(item)"
                  :title="isArchived ? 'Arşiv modunda bu işlem yapılamaz' : isDisabled ? 'Bu işlem şu anda yapılamaz' : 'Aracı planlamadan çıkar'"
                >
                  <i class="fas fa-trash"></i>
                  Sil
                </button>
              </div>
            </td>
          </tr>
          <tableLoader :load="load" :length="List.length" colspan="8" />
        </tbody>
      </table>
    </div>
    <div class="px-4 h-1/6 flex items-center">
      <PaginationComponents
        v-if="totalCount > 0"
        :totalRowCount="totalCount"
        :pageCount="pageCount"
        :currentPage="currentPage + 1"
        @changePage="(r) => (currentPage = r - 1)"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import headerItem from "./header.vue";
//Global Components
import tableLoader from "@/components/general/table-loader.vue";
import PaginationComponents from "@/components/general/pagination.vue";
import userEditModal from "@/components/modals/userEditModal/index.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";

// local components
import addModal from "../add.vue";
import equipmentSelectorModal from "../../equipment-selector.modal.vue";
//Networking
import axios from "axios";
import { bulkPlanning } from "@/networking/urlmanager";
import { addVehicleExtraTour } from "../../../tools/collectivePlanningService";
import piratedriverModal from "../../addPriatedDriver/piratedriver.modal.vue";

export default {
  props: [
    "rowId",
    "isDisabled",
    "orderNo",
    "customerList",
    "customers",
    "orderItem",
    "dataLoad",
    "isArchived",
  ],
  components: {
    tableLoader,
    PaginationComponents,
    addModal,
    equipmentSelectorModal,
    piratedriverModal,
    userEditModal,
    asyncBtn,
    headerItem,
  },
  data() {
    return {
      load: false,

      // Ayrılmış loading state'leri
      stopAllLoading: false,
      startAllLoading: false,
      vehicleActionLoading: {}, // Her araç için ayrı loading
      newTaskLoading: {}, // Yeni görev ekleme loading
      deleteLoading: {}, // Silme işlemi loading

      List: [],
      totalCount: 0,
      pageCount: 0,
      currentPage: 0,
      selected: "",
      activeSpot: false,
      newisStopped: 2,
      isAllStopped: 1,
      type: 1,
      searchQuery: "",
      selectedEquipmentCategories: [], // Equipment selection for vehicle planning
      counts: {
        assigned: 0,
        available: 0,
        deleted: 0,
        rejected: 0,
      },
    };
  },
  methods: {
    openEquipmentModal() {
      this.$modal.show('collective-equipment-modal');
    },
    handleEquipmentSelected(categories) {
      this.selectedEquipmentCategories = categories;
    },
    handleSearch() {
      this.currentPage = 0;
      this.getAll();
    },
    getAll(isStart = false) {
      if (isStart) this.currentPage = 0;

      //this.List = [];
      this.load = true;

      let queryParams = {
        rowId: this.rowId,
        page: this.currentPage,
        search: this.searchQuery || "",
        listType: this.vehicleListType || "active",
      };

      // Sipariş filtresi sadece görevli araçlar sekmesinde kullanılır
      if (this.vehicleListType === "active" && this.orderFilter) {
        queryParams.orderNo = this.orderFilter;
      }

      const params = new URLSearchParams(queryParams);

      axios
        .get(`${bulkPlanning.vehiclesAll}?${params.toString()}`, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.List = res.data.data.detail;
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;

          // Araç sayılarını güncelle (API'den geliyorsa)
          if (res.data.data.counts) {
            this.counts = res.data.data.counts;
            // Üst bileşene sayıları bildir
            this.$emit("updateCounts", this.counts);
          }
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },

    stopControl() {
      // Ek güvenlik kontrolü
      if (!this.canStopAll) {
        this.swalBox(
          "info",
          "Bilgi",
          "Tüm araçlar zaten durdurulmuş durumda.",
          false,
          "Tamam"
        );
        return;
      }

      this.isAllStopped = 1;
      this.type = 2;
      this.orderStatus(false);
    },

    startControl() {
      // Ek güvenlik kontrolü
      if (!this.canStartAll) {
        this.swalBox(
          "info",
          "Bilgi",
          "Tüm araçlar zaten başlatılmış durumda.",
          false,
          "Tamam"
        );
        return;
      }

      this.isAllStopped = 2;
      this.type = 2;
      this.orderStatus(false);
    },

    stopedControl(item) {
      // Araç için spesifik loading state
      this.$set(this.vehicleActionLoading, item.id, true);
      if (item.isStopped == 2) {
        this.type = 1;
        this.newisStopped = 1;
        this.isAllStopped = 0;
        this.orderStatus(true, item);
      } else {
        this.newisStopped = 2;
        this.type = 1;
        this.isAllStopped = 0;
        this.orderStatus(true, item);
      }
    },
    async addNewTask(item) {
      try {
        // Araç için spesifik loading state
        this.$set(this.newTaskLoading, item.id, true);
        await addVehicleExtraTour(this.$store.state.userData.token, {
          rowId: Number(item.id),
          driverTC: item.driverTC,
          driverName: item.name,
          dorse: item.dorse,
          bulkId: Number(this.rowId),
          plaque: item.plaque,
          stateId: item.lastStateId,
          isActive: 1,
        });
        this.swalBox(
          "success",
          this.$t("general.successTitle"),
          "",
          false,
          this.$t("general.OkayTitle")
        );

        let vehicle = this.List.find((i) => i.id == item.id);
        if (vehicle) {
          vehicle.lastStateId = 1;
          vehicle.lastStateName = "Onay Bekliyor";
        }
      } catch (err) {
        console.log("errrrr", err);
        this.swalBox(
          "warning",
          "Uyarı",
          err.response.data.message,
          false,
          this.$t("general.OkayTitle")
        );
      } finally {
        this.$set(this.newTaskLoading, item.id, false);
      }
    },
    orderStatus(isSingle, item) {
      // Hangi loading state'i aktif olacağını belirle
      if (isSingle) {
        // Tek araç işlemi - zaten stopedControl'de set edildi
      } else {
        // Toplu işlem
        if (this.isAllStopped === 1) {
          this.stopAllLoading = true;
        } else {
          this.startAllLoading = true;
        }
      }

      let newItem = [item];
      axios
        .post(
          bulkPlanning.vehicleSet,
          {
            isStopped: isSingle ? this.newisStopped : 0,
            isAllStopped: !isSingle ? this.isAllStopped : 0,
            bulkId: this.rowId,
            orderNo: this.orderNo,
            list: this.type == 1 ? newItem : this.List,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then((res) => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          this.getAll();
          this.$emit("refresh", true);
          this.changeOrderReceivedTonnage();

          // this.$modal.hide('vehicle-list-modal');
        })
        .catch((err) => {
          //this.errorBox(err.response);

          if (Object.keys(err.response.data.data).length == 6) {
            this.$swal.fire({
              icon: "warning",
              title: "UYARI !",
              showConfirmButton: true,
              width: "800px",
              html: `
                <div>
                  <h1 >Bu siparişe daha fazla araç ekleyemezsiniz! Çünkü Kalan tonaj İhtiyacı 0 veya altındadır.</h1>
                  <div style="margin-left: 30px; border-bottom: 1px solid #f5f5f5; padding: 10px 0px 4px 0px; display: flex; "><strong style="">Sipariş Bilgileri</strong></div>
                  <p  style="width: max-content; margin-left:30px; margin-top:4px;"><strong>Sipariş Tonajı : </strong> ${err.response.data.data.orderTonnage}</p>
                  <p style="width: max-content; margin-left:30px; margin-top:4px;"><strong>Kalan Tonaj İhtiyacı : </strong> ${err.response.data.data.remainingTonnageForJob}</p>
                  <p style="width: max-content; margin-left:30px; margin-top:4px;"><strong>Toplam Taşınan ve Yükünü Almaya Hazır Araçların Toplam Tonajı : </strong> ${err.response.data.data.totalTonnageUsed}</p>
                </div>
          `,
            });
          } else if (Object.keys(err.response.data.data).length == 5) {
            this.$swal.fire({
              icon: "warning",
              title: "UYARI !",
              showConfirmButton: true,
              width: "800px",
              html: `
                <div>
                  <h1> Bu siparişe en fazla ${Math.ceil(
                    err.response.data.data.remainingTonnageForJob / 26
                  )} adet araç eklenebilir!</h1>
                  <div style="margin-left: 30px; border-bottom: 1px solid #f5f5f5; padding: 10px 0px 4px 0px; display: flex; "><strong style="">Sipariş Bilgileri</strong></div>
                  <p  style="width: max-content; margin-left:30px; margin-top:4px;"><strong>Sipariş Tonajı : </strong> ${
                    err.response.data.data.orderTonnage
                  }</p>
                  <p style="width: max-content; margin-left:30px; margin-top:4px;"><strong>Kalan Tonaj İhtiyacı : </strong> ${
                    err.response.data.data.remainingTonnageForJob
                  }</p>
                  <p style="width: max-content; margin-left:30px; margin-top:4px;"><strong>Toplam Taşınan ve Yükünü Almaya Hazır Araçların Toplam Tonajı : </strong> ${
                    err.response.data.data.totalTonnageUsed
                  }</p>
                </div>
          `,
            });
          } else {
            this.swalBox(
              "warning",
              "Uyarı",
              err.response.data.message,
              false,
              this.$t("general.OkayTitle")
            );
          }
        })
        .finally(() => {
          // Loading state'lerini temizle
          if (isSingle && item) {
            this.$set(this.vehicleActionLoading, item.id, false);
          } else {
            this.stopAllLoading = false;
            this.startAllLoading = false;
          }
        });
    },
    changeOrderReceivedTonnage() {
      this.$emit("changeOrderReceivedTonnage", {
        vehicleLength: this.List.length,
        isAllStopped: this.isAllStopped,
      });
    },
    userEditModal(item) {
      this.activeSpot = false;
      this.selected = item.plaque;
      this.$modal.show("ueserEdit-modal");
    },
    deleteItem(item) {
      if (item.lastStateId > 4 && item.lastStateId < 8) {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          ` ${item.plaque} Plakalı aracın üzerinde yük olduğu için silemezsiniz.`,
          false,
          this.$t("general.OkayTitle")
        );
        return;
      }

      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        ` ${item.plaque} Plakalı Aracı  planlamadan çıkarmak istediğinize emin misiniz?`,
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          // Silme işlemi için spesifik loading
          this.$set(this.deleteLoading, item.id, true);
          axios
            .post(
              bulkPlanning.vehicleDelete,
              {
                rowId: item.id.toString(),
                plaque: item.plaque.toString(),
                bulkId: this.rowId,
                orderNo: this.orderNo,
                driverTc: item.driverTC,
              },
              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
              this.getAll();
            })
            .catch((err) => {
              this.errorBox(err.response);
            })
            .finally(() => {
              this.$set(this.deleteLoading, item.id, false);
            });
        }
      });
    },
  },
  computed: {
    isBulk() {
      return (
        this.List.filter((v) => Number(v.isTaskActive) === 1).length !=
        this.totalCount
      );
    },
    canStopAll() {
      if (this.List.length === 0) return false;
      // En az bir araç çalışıyor durumda mı kontrol et (isStopped === 2)
      return this.List.some((item) => item.isStopped === 2);
    },

    // Tümünü başlat butonunun aktif olup olmadığını kontrol eder
    canStartAll() {
      if (this.List.length === 0) return false;
      // En az bir araç durmuş durumda mı kontrol et (isStopped === 1)
      return this.List.some((item) => item.isStopped === 1);
    },
  },
  created() {
    this.getAll();
  },
  watch: {
    currentPage() {
      this.getAll();
    },
  },
  filters: {
    dateFormat(val) {
      return moment(val).format("LLLL");
    },
  },
};
</script>

<style scoped>
/* Buton ve arayüz elemanları için temel stiller */
.process-btn {
  @apply bg-blue-600 hover:bg-blue-700 text-white rounded px-2 py-1 transition-colors duration-150;
}

/* Disabled buton stili */
.text-opacity-30 {
  opacity: 0.3;
}

/* Tablo stilleri - tablonun düzgün görüntülenmesi için */
/* .table-height-value {
  max-height: calc(100vh - 320px);
} */
.table-height {
  max-height: 63vh !important;
  min-height: 63vh;
}
</style>
